// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"liveBlog-m__wrapper__1bjfz","ad-slot":"liveBlog-m__ad-slot__2bFrn","data-wrapper":"liveBlog-m__data-wrapper__1d8Op"};